module.exports = __webpack_public_path__ + "img/4stars.9b0a2ac8.jpg";